<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="section-title">
          {{ title }}
        </h1>
      </div>
      <!-- /.col-12 -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</template>

<script>
  export default {
    name: 'Title',
    props: {
      title: String
    }
  };
</script>

<style scoped lang="scss">
  .section-title {
    margin: 0;

    font-family: 'Lato', sans-serif;
    text-align: center;
    font-weight: 700;
    color: #bb3a31;
  }

  @media (max-width: 1199px) {
    .section-title {
      margin-top: 30px;
    }
  }
</style>
